<div class="sg-input-container">
  <h2 class="sg-input-title small bold" *ngIf="label">{{ label }}</h2>
  <p class="sg-input-description extra-small" *ngIf="description">{{ description }}</p>
  <textarea
    class="textarea"
    matInput
    (input)="onInputChange($event)"
    (blur)="onBlur()"
    [attr.aria-label]="label"
    [placeholder]="placeholder"
    [rows]="rows"
    [value]="value"
  ></textarea>
</div>
